// Purpose: Legally required imprint page according to §5 TMG
// Author: AI Assistant
// Last Updated: 2025-08-03

import React from 'react';
import MetaTags, { getLegalPageStructuredData } from '../ui/MetaTags';
import './ContentPage.scss'; // reuse same typography / spacing

const ImprintPage = () => (
  <>
    <MetaTags
      title="Imprint - Elodie Carstensen"
      description="Legal disclosure (Impressum) for Elodie Carstensen, Berlin."
      url="https://www.elodiecarstensen.com/imprint"
      type="article"
      structuredData={getLegalPageStructuredData(
        'Imprint - Elodie Carstensen',
        'https://www.elodiecarstensen.com/imprint'
      )}
    />
    <div className="content-page imprint-page">
      <h1>Imprint</h1>
      <p>
        <strong>Elodie Carstensen</strong>
        <br /> Kadiner Str. 20A
        <br /> 10243 Berlin
      </p>
      <p>
        Email: <a href="mailto:info@elodiecarstensen.com">info@elodiecarstensen.com</a>
      </p>
      <p>
        This imprint is provided according to section 5&nbsp;(1) of the German Telemedia Act (TMG).
      </p>
    </div>
  </>
);

export default ImprintPage;
